//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const DetailsService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/course/details/loadscreenview", vo, successCallback, failureCallback);
    },
    deleteSection: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/course/details/deletesection", { id }, successCallback, failureCallback);
    },
    publishCourse: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/course/details/publishcourse", { id }, successCallback, failureCallback);
    },
    reorder: (courseId, destId, nextId, sourceId, direction, successCallback, failureCallback) => {
        ApiService.post("/web/admin/course/details/reorder", { courseId, destId, nextId, sourceId, direction }, successCallback, failureCallback);
    },
    unpublishCourse: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/course/details/unpublishcourse", { id }, successCallback, failureCallback);
    },
    generateUnits: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/course/details/generateunits", vo, successCallback, failureCallback);
    },
};

export default DetailsService;